import api from './api';

export const usuarioService = {
  getAll,
  getById,
  create,
  update,
  destroy,
  getLicencas
};

function getAll(page = 1, limit = 25, status = '', query = '') {
  let queryStr = `?page=${page}&limit=${limit}${status && `&status=${status}`}${query && `&query=${query}`}`;
  return api.get(`${process.env.VUE_APP_ROOT_API}/usuarios${queryStr}`);
}

function getById(id) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/usuarios/${id}`);
}

function create(usuario) {
  return api.post(`${process.env.VUE_APP_ROOT_API}/usuarios`, usuario);
}

function update(usuario) {
  return api.put(`${process.env.VUE_APP_ROOT_API}/usuarios/${usuario._id}`, usuario);
}

function destroy(id) {
  return api.delete(`${process.env.VUE_APP_ROOT_API}/usuarios/${id}`);
}

function getLicencas(id_usuario) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/usuarios/${id_usuario}/licencas`);
}